module.exports = __webpack_public_path__ + "static/media/dqp-logo-final.641698f0.png";